import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityUpdateAttributeAnswer } from '../../projectDetailsActivities.models';

export const UpdateAttributeAnswerActivity = ({ values }: IProjectActivity<IProjectActivityUpdateAttributeAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.updateAnswer')}
      <b>{values.originalAnswer}</b> {t('activity_description_common.to')} <b>{values.answer}</b> {t('activity_description_common.from')}{' '}
      {t('activity_description_common.attribute')} <b>{values.attribute}</b>.
    </span>
  );
};
